import { Stack, Typography } from '@mui/material';

/**
 * NudgeForMe brand lockup.
 *
 * Orbit icon:
 *   ring = the waiting thread
 *   dot  = the nudge
 *
 * Props:
 *   light   — true on dark/night surfaces, false on paper
 *   compact — icon only
 *   size    — 'md' | 'lg'
 */

function OrbitIcon({ light = false, px = 30 }) {
  const ring = light ? 'var(--amber)' : 'var(--ink)';
  const dot = light ? 'var(--amber)' : 'var(--amber-deep)';

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 30 30"
      aria-hidden="true"
      focusable="false"
    >
      <circle
        cx="13"
        cy="17"
        r="8"
        fill="none"
        stroke={ring}
        strokeWidth="2.8"
      />

      <circle
        cx="24"
        cy="7"
        r="4"
        fill={dot}
      />
    </svg>
  );
}

export function Brand({
  light = false,
  compact = false,
  size = 'md',
}) {
  const lg = size === 'lg';

  if (compact) {
    return (
      <OrbitIcon
        light={light}
        px={lg ? 44 : 30}
      />
    );
  }

  return (
    <Stack
      direction="row"
      spacing={lg ? 1.4 : 1}
      alignItems="center"
      flexWrap="nowrap"
      aria-label="NudgeForMe"
    >
      <OrbitIcon
        light={light}
        px={lg ? 44 : 30}
      />

      <Typography
        component="span"
        sx={{
          position: 'relative',
          display: 'inline-flex',
          flexShrink: 0,
          pb: lg ? '8px' : '6px',

          fontFamily: 'var(--display)',
          fontWeight: 800,
          fontSize: lg ? 30 : 21,
          lineHeight: 1,
          letterSpacing: '-0.025em',
          whiteSpace: 'nowrap',

          color: light
            ? 'var(--night-ink)'
            : 'var(--ink)',

          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            right: '18%',
            bottom: 0,
            height: lg ? '4px' : '3px',
            borderRadius: '999px',
            background:
              'linear-gradient(90deg, var(--amber), var(--peri))',
          },
        }}
      >
        NudgeForMe
      </Typography>
    </Stack>
  );
}